import React from 'react';
import { Progress } from '@ncoder/ui';

interface TrainingMetricProps {
  label: string;
  value: string;
}

export const TrainingMetric: React.FC<TrainingMetricProps> = ({
  label,
  value,
}) => {
  return (
    <div>
      <p className="text-muted-foreground">{label}</p>
      <p className="font-medium">{value}</p>
    </div>
  );
};

interface TrainingProgressBarProps {
  progress: number;
}

export const TrainingProgressBar: React.FC<TrainingProgressBarProps> = ({
  progress,
}) => {
  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <span>Training Progress</span>
        <span>{progress}%</span>
      </div>
      <Progress value={progress} className="w-full" />
    </div>
  );
};
